import { TmCart } from '@/tscapi/model/cart';

//cart object exposed for analytics
export const setupAnalyticsData = (cart: TmCart) => {
    window.analyticsData.cart = cart;
};

//prepare analytics object that highlights item that was removed and qty
//looks in previousCart, finds cartlineid of item being removed
export const setupAnalyticsRemove = (newCart: TmCart, previousCart: TmCart, cartLineId) => {
    const currentQty = previousCart.CartLines.find((prevCartLine) => cartLineId == prevCartLine.Id).InCart.Quantity;
    const currentItemNo = previousCart.CartLines.find((prevCartLine) => cartLineId == prevCartLine.Id).CartLineItem
        .ItemNo;
    const changedProduct = previousCart.Products.find((product) => product.ItemNo == currentItemNo);
    window.analyticsData.cart = newCart;
    window.analyticsData.productChange = {};
    window.analyticsData.productChange.product = changedProduct;
    window.analyticsData.productChange.quantity = -currentQty;
    if (previousCart.CartLines.find((prevCartLine) => cartLineId == prevCartLine.Id).CartLineItem.IsSoldOut) {
        window.analyticsData.productChange.reason = 'sold out';
    }
    window.analyticsData.event.eventTitle = 'change-in-cart';
};

//fire off 'cart updated event' so Truefit component can refresh recommendations
export const setupTruefitUpdateEvent = (cart: TmCart) => {
    if (cart != null && cart.CartLines.length > 0) {
        const truefitEvent = new CustomEvent('tf-update', { detail: { cart: cart } });
        document.dispatchEvent(truefitEvent);
    }
};

//send analytics change qty event;
export const setupAnalyticsUpdateQty = (newCart: TmCart, variables, context) => {
    const cartLineId = variables?.lineId;
    const previousCart: TmCart = context?.previousBag;
    const prevCartline = previousCart.CartLines.find((PreviousCartLine) => cartLineId == PreviousCartLine?.Id);
    const changedProduct = previousCart.Products.find(
        (product) => prevCartline.CartLineItem?.ItemNo == product?.ItemNo,
    );
    window.analyticsData.cart = newCart;
    window.analyticsData.productChange = {};
    window.analyticsData.productChange.product = changedProduct;
    window.analyticsData.productChange.quantity = variables?.addRemove;
    window.analyticsData.event.eventTitle = 'change-in-cart';
};

//when pressing 'cancel order modification' button on shopping bag
export const setupAnalyticsCancelModification = () => {
    window.analyticsData = window.analyticsData || {};
    window.analyticsData.page = window.analyticsData.page || {};
    window.analyticsData.page.pageTitle = 'order modification cancel';
    window.analyticsData.form = window.analyticsData.form || {};
    window.analyticsData.form.formStepName = 'cancel modification';
};
